module.exports = __webpack_public_path__ + "238d4411d8e839047b3976426a68f861.pdf";